import { TableActionsCreator } from '@ublique/components'

export const filtering = {
  canSearch: false,
  floatingFilter: true,
  filterParams: {
    applyMiniFilterWhileTyping: true
  }
}
export const pagination = {
  pagination: true,
  paginationPageSize: 10
}
export const styling = {
  flex: 1,
  resizable: true,
  animateRows: true
  // suppressContextMenu: true
}

export const defaultColumnDefs = {
  sortable: true
}

export const getTablecActions = ({
  t,
  refreshButtonAction,
  exportCsvButtonAction
}) => {
  const refreshButton = {
    label: t('Document:UpdateButton'),
    action: () => refreshButtonAction()
  }
  const csvButton = {
    label: t('Shell:Export'),
    action: () => exportCsvButtonAction()
  }

  const builder = new TableActionsCreator() //
  builder.addUbliqueBtn(refreshButton)
  builder.addUbliqueBtn(csvButton)
  return builder.getTableButtons()
}

export const getColumnDefs = (t, additionalColumns = []) => {
  return [
    {
      headerName: t('ScenarioWarning.SCENARIO_ID'),
      field: 'scenarioId',
      colId: 'scenarioId',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: t('ScenarioWarning.CREATION_DATE'),
      field: 'creationDate',
      colId: 'creationDate',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: t('ScenarioWarning.USER_ID'),
      field: 'userId',
      colId: 'userId',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: t('ScenarioWarning.MESSAGE'),
      field: 'message',
      colId: 'message',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: t('ScenarioWarning.INVOKER_SDK'),
      field: 'invokerSdk',
      colId: 'invokerSdk',
      filter: 'agTextColumnFilter'
    },
    {
      headerName: t('ScenarioWarning.PROJECT_NAME'),
      field: 'projectName',
      colId: 'projectName',
      filter: 'agTextColumnFilter'
    },
    ...additionalColumns.map((key) => ({
      headerName: `${key}`,
      field: `${key}`,
      colId: 'customPropsList',
      filter: 'agTextColumnFilter'
    }))
  ]
}
